<template>
  <div class="upload-page">
    <div class="main" v-if="orderFlag">
      <div class="status_info">
        <div class="status_left">金融状态</div>
        <div class="status_right">{{orderInfo.crmFinapplystatusC}}</div>
      </div>
      <div class="content">
        <div class="info-part">
          <div class="item">
            <div class="label">
              <p>申请人姓名</p>
            </div>
            <div class="detail">
              <p>{{orderInfo.erpnameC}}</p>
            </div>
          </div>
          <div class="phone">
            <div class="title">手机号码</div>
            <div class="number">{{orderInfo.erpmobileC}}</div>
          </div>
          <div class="item">
            <div class="label">
              <p>备注</p>
            </div>
            <div class="detail">
              <div v-if="!descFlag" v-html="orderInfo.erpDescriptionC"></div>
              <div v-if="descFlag" v-html="desc"></div>
            </div>
          </div>
          <div class="more" v-if="arrowShow && descFlag" @click="descFlag = false" >
            <p>展开查看更多</p>
            <img src="../../assets/image/Upload/arrow_down.png"/>
          </div>
          <div class="more" v-if="arrowShow && !descFlag" @click="descFlag = true">
            <p>收起</p>
            <img src="../../assets/image/Upload/arrow_up.png"/>
          </div>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <!-- 影像件要求 -->
      <div class="portrait">
        <div class="img_title" @click="imageFlag=true" :class="{active:imageFlag}">
          <p>影像件要求</p>
          <div :class="{border_line:imageFlag}"></div>
        </div>
        <div class="original" @click="imageFlag=false" :class="{active:!imageFlag}">
          <p>原件要求</p>
          <div :class="{border_line:!imageFlag}"></div>
        </div>
      </div>
      <!-- <div class="line"></div> -->
      <div class="upload-part">
        <div class="tab_header">
          <div class="all" v-if="imageFlag">
            <img src="../../assets/image/Upload/tab_img.png" alt="" >
          </div>
          <div class="org" v-if="!imageFlag">
            <img src="../../assets/image/Upload/original.png" alt="">
          </div>
          <div class="claim">
            <div>请根据表格，上传影像</div>
            <div>V.20200825</div>
          </div>
        </div>
      </div>
      <div class="image_part">
        <div class="uploaded_status" v-if="imagePaths.length > 0">
          <div class="name">
            <p>已上传</p>
            <van-loading size="24px" v-if="images.length == 0">加载中...</van-loading>
          </div>
          <div class="uploaded_all" v-if="images.length > 0">
            <div class="upload_img_show" v-for="item,index in images" :data-code="index" :key="index" @click="lookimg(index)">
              <img :src="item"/>
            </div>
          </div>
        </div>
        <div class="upload_img_caption">
          <p>上传影像</p>
        </div>
        <van-uploader ref="vantupload" @delete="del" :after-read="afterRead" :before-read="beforeRead" v-model="fileList"
                      preview-options.closeable="true" multiple="true" preview-size="70" max-count="20"/>
        <button @click="uploadList">确认上传({{fileArr.length}})</button>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
  import Vue from "vue";
  import common from "../../utils/common";
  import VueCookies from "vue-cookies";
  import {Dialog, ImagePreview, Loading } from "vant";
  Vue.use(VueCookies);
  Vue.use(Dialog);
  Vue.use(Loading);
  Vue.use(ImagePreview);
  export default {
    name: "uploadImage",
    data() {
      return {
        imagePaths: [],
        images: [],
        ImagePreviewDialog: '',
        lineFlag: true,
        fileList: [],
        erpidC: null,
        orderInfo: {},
        orderFlag: false,
        desc: null,
        descFlag: true,
        arrowShow: false,
        fileArr: [],
        imageFlag: true
      };
    },
    created() {
      document.title = sessionStorage.getItem("erpidc")
    },
    mounted() {
      const that = this;
      if (!VueCookies.get("tokenflag") || !sessionStorage.getItem("access_token")) {
        common.redirect(this, "upload_login");
        return;
      }
      if (!sessionStorage.getItem("erpidc")) {
        common.redirect(this, "result");
        return;
      }
      this.erpidC = sessionStorage.getItem("erpidc");
      this.search(this.erpidC);
      // 图片请求展示
      // axios.defaults.headers.post['Authorization'] = 'Bearer ' + sessionStorage.getItem("access_token")
      that.$axios({
        method: 'post',
        url: '/crm/daihou/getfilename',
        headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") },
        params: {erpId: that.erpidC}
      }).then(function (res) {
        that.imagePaths = res.data.data
        let imagesLength = 0
        let imageArr = []
        if(!common.isEmpty(res.data.data.length)){
          imagesLength = res.data.data.length
        }
        for (let item of res.data.data) {
          that.$axios({
            method: 'get',
            url: 'admin/file/dl',
            headers: { Authorization: "Bearer " + sessionStorage.getItem("access_token") },
            responseType: 'arraybuffer',
            params: {fileName: item.filePath}
          }).then(function (res) {
            let bufferUrl = 'data:image/png;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            imageArr.push(bufferUrl)
            if(imagesLength == imageArr.length) {
              that.images = imageArr
            }
          }).catch(function (err) {
            common.tipToast("已上传影响照片显示错误！！！")
          })
        }
      }).catch(function (error) {
        common.tipToast("已上传影响照片获取错误！！！")
      })
    },
    // beforeRouteLeave(to,from,next){
    //   this.ImagePreviewDialog.close()
    //   next()
    // },
    methods: {

      lookimg(index) {
        this.ImagePreviewDialog = ImagePreview({
          images: this.images,
          startPosition: index,
          closeable: true,
          closeOnPopstate: true
        })

      },

      // 获取订单信息
      search(erpidc) {
        const that = this;
        that.fileList = [];
        that.fileArr = [];
        that.orderFlag = true;
        let orderList = JSON.parse(sessionStorage.getItem("lastresult"));
        that.orderInfo = orderList.filter(item => {
          return item.erpidC == erpidc;
        })[0];
        if (!common.isEmpty(that.orderInfo.erpDescriptionC)) {
          if (that.orderInfo.erpDescriptionC.length > 49) {
            that.desc = that.orderInfo.erpDescriptionC.slice(0, 49);
            that.descFlag = true;
            that.arrowShow = true;
          } else {
            that.descFlag = false;
          }
        }
      },

      beforeRead(file) {
        //上传之前校验
        if (!common.isEmpty(file.length)) {
          for (let fileItem of file) {
            if (
              fileItem.type !== "image/jpeg" &&
              fileItem.type !== "image/png" &&
              fileItem.type !== "image/jpg"
            ) {
              common.tipToast("只允许上传jpg/png格式的图片！");
              return false;
            }
          }
        } else {
          if (
            file.type !== "image/jpeg" &&
            file.type !== "image/png" &&
            file.type !== "image/jpg"
          ) {
            common.tipToast("只允许上传jpg/png格式的图片！");
            return false;
          }
        }
        return true;
      },

      afterRead(file) {
        //文件读取完成后的回调函数
        let [totalSize, imgSize, imgSrc] = [0, 0, null];
        if (!common.isEmpty(file.length)) {
          for (let key in file) {
            this.compress(file[key], parseInt(key) + 1);
          }
        } else {
          this.compress(file, 1);
        }
      },
      // 压缩照片 压缩后上传文件超过1M会上传失败
      compress(file, index) {
        let reg = new RegExp("-", "g"); //g代表全部
        const that = this;
        lrz(file.file, {quality: 0.4}).then(function (rst) {
          if (rst.fileLen > 1000000) {
            that.fileList = that.fileList.slice(0, -1);
            common.tipToast("照片过大，请重新上传");
            return;
          }
          rst.file.filename = rst.origin.name.replace(reg, "");
          let formData = new FormData();
          let imagename = rst.file.filename;
          if (rst.file.filename == "image.jpg") {
            imagename = that.erpidC + rst.fileLen + ".jpg";
          }
          if (rst.file.filename == "image.png") {
            imagename = that.erpidC + rst.fileLen + ".png";
          }
          formData.append("file", rst.file, imagename);
          formData.append("bucket", "daihou");
          formData.append("subcatalog", that.erpidC);
          let obj = {
            key: file,
            val: formData
          };
          that.fileArr.push(obj);
        });
      },
      // 删除按钮
      del(file) {
        if (!common.isEmpty(this.fileArr) && this.fileArr.length > 0) {
          let arr = this.fileArr.filter(item => {
            return item.key.file.name != file.file.name;
          });
          this.fileArr = arr;
        }
      },
      // 确认上传
      uploadList() {
        if (common.isEmpty(this.fileArr) || this.fileArr.length == 0) {
          common.tipToast("请上传照片！！！");
          return;
        }
        Dialog.confirm({
          title: "确认上传影像？",
          className: "confirmBox"
        }).then(() => {
          this.fileArr.map(item => {
            this.upload(item);
          });
          common.tipToast("图片上传成功")
          this.$axios({
            method: "post",
            url: "/crm/daihou/erpid",
            params: {erpId: this.erpidC},
            headers: {
              Authorization: "Bearer " + sessionStorage.getItem("access_token")
            }
          }).then(function (res) {
          }).catch(function (err) {
          });
        }).catch(() => {
          // on cancel
          return
        });
      },
      // 调用上传接口
      async upload(item) {
        const that = this;
        let file = item.key;
        let formData = item.val;
        file.status = "uploading";
        file.message = "上传中...";
        await that
          .$axios({
            method: "post",
            url: "/admin/file/newload",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + sessionStorage.getItem("access_token")
            }
          })
          .then(function (res) {
            if (res.data.code == "0") {
              file.status = "done";
              file.message = "上传成功";
            } else {
              file.status = "failed";
              file.message = "上传失败！";
            }
          })
          .catch(function (err) {
            file.status = "failed";
            file.message = "上传失败";
          });
      }
    }
  };
</script>

<style scoped>
  .upload-page {
    margin: 0 auto;
    padding-top: 0.28rem;
    padding-bottom: 1.3rem;
    width: 7.5rem;
    min-height: 100vh;
    background-color: #fafafa;
  }

  .status_info {
    padding: 0 0.42rem;
    height: 1rem /* 100/100 */;
    background-color: #fff;display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 0.26rem /* 26/100 */;
    color: #a2a2a2;
  }

  .status_info .status_right {
    color: #444;
  }

  .main .phone {
    margin-top: 0.24rem /* 24/100 */;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 0.42rem /* 42/100 */;
    font-size: 0.26rem /* 26/100 */;
    color: #a2a2a2;
  }

  .main .phone .number {
    color: #444;
  }

  .upload-page > .header {
    padding: 0.34rem 0.42rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 0 0.14rem 0 rgba(0, 0, 0, 0.1);
  }

  .upload-page > .header > .top,
  .upload-page > .header > .bottom {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;
  }

  .upload-page > .header > .bottom {
    margin-top: 0.2rem;
  }

  .upload-page > .header > .top > div > p {
    font-size: 0.3rem;
    font-weight: 700;
    color: #151c24;
    letter-spacing: 0;
    line-height: 0.45rem;
  }

  .upload-page > .header > .top > div > img {
    width: 0.3rem;
    height: 0.45rem;
  }

  .upload-page > .header > .bottom > input {
    padding-left: 0.17rem;
    width: 4.5rem;
    height: 0.78rem;
    outline: none;
    background: #fafdff;
    border: 1px solid #54b4ff;
    font-size: 0.26rem;
  }

  .upload-page > .header > .bottom > button {
    width: 1.88rem;
    height: 0.78rem;
    border-width: 0;
    outline: none;
    font-size: 0.26rem;
    color: #ffffff;
    background: #54b4ff;
  }

  .upload-page > .main > .nothing {
    margin-top: 2.72rem;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    font-size: 0;
  }

  .upload-page > .main > .nothing > img {
    width: 1.99rem;
    height: 1.99rem;
  }

  .upload-page > .main > .nothing > p {
    margin-top: 0.53rem;
    font-size: 0.3rem;
    color: #6b6c6c;
    letter-spacing: 0;
    line-height: 0.42rem;
  }

  .upload-page > .main > .caption {
    height: 1.2rem;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1.2rem;
    color: #333;
    background-color: #fff;
    text-align: center;
  }

  .upload-page > .main > .content {
    margin-top: 0.2rem;
    padding: 0.16rem 0.42rem 0 0.42rem;
    background-color: #fff;
  }

  .upload-page > .main > .content > .info-part {
    padding-bottom: 0.42rem;
  }

  .upload-page > .main > .content > .info-part > .item {
    margin-top: 0.16rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }

  .upload-page > .main > .content > .info-part > .item > .label > p {
    font-size: 0.26rem;
    /* color: #8b93a4; */
    color: #a2a2a2;
    letter-spacing: 0;
    line-height: 0.42rem;
  }

  .upload-page > .main > .content > .info-part > .item > .detail {
    max-width: 5.15rem;
  }

  .upload-page > .main > .content > .info-part > .item > .detail > div,
  .upload-page > .main > .content > .info-part > .item > .detail > p {
    margin: 0;
    font-size: 0.26rem;
    color: #444;
    letter-spacing: 0;
    text-align: right;
    line-height: 0.42rem;
    white-space: pre-wrap;
    text-align: justify;
  }

  .upload-page > .main > .content > .info-part > .item > .detail > pre {
    margin: 0;
  }

  .upload-page > .main > .content > .info-part > .more {
    margin-top: 0.16rem;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-end;
    font-size: 0;
  }

  .upload-page > .main > .content > .info-part > .more > p {
    font-size: 0.26rem;
    /* color: #8896a5; */
    color: #9e9e9e;
    letter-spacing: 0;
    text-align: right;
    line-height: 0.26rem;
  }

  .upload-page > .main > .content > .info-part > .more > img {
    margin-left: 0.075rem;
    width: 0.22rem;
    height: 0.13rem;
  }

  .upload-page .main .portrait {
    background-color: #fff;
    margin-top: 0.23rem;
    height: 0.81rem /* 81/100 */;
    display: flex;
    align-items: center;
    font-size: 0.28rem /* 28/100 */;
    color: #666;
    padding-left: 0.42rem /* 42/100 */;
    border-bottom: 0.01rem solid #e5e5e5;
  }

  .upload-page .main .portrait .img_title {
    position: relative;
    display: flex;
    align-items: center;
    height: 0.81rem /* 81/100 */;
  }

  .upload-page .main .portrait .original {
    display: flex;
    align-items: center;
    margin-left: 0.56rem /* 56/100 */;
    height: 0.81rem /* 81/100 */;
    position: relative;
  }
 .active {
    font-size: 0.32rem /* 32/100 */;
    color: #151c24;
    font-weight: bold;
    display: block;
  }


  .upload-page .main .portrait .border_line {
    color: #000;
    position: absolute;
    width: 0.7rem /* 70/100 */;
    border: 0.01rem /* 1/100 */ solid #54b4ff;
    bottom: 0;
    left: 50%;
    margin-left: -0.35rem /* 35/100 */;
    font-size: 0.32rem /* 32/100 */;
    background-color: #54b4ff;
  }

  .upload-page .main .upload-part {
    background-color: #fff;
    padding: 0.23rem 0.42rem;
  }

  .upload-page .main .upload-part .tab_header .all,
  .upload-page .main .upload-part .tab_header .org{
    width: 6.66rem;
  }

  .upload-page .main .upload-part img {
    width: 100%;
    height: 100%;
  }

  .upload-page .main .upload-part .claim {
    margin-top: 0.06rem /* 6/100 */;
    height: 0.42rem /* 42/100 */;
    display: flex;
    justify-content: space-between;
    font-size: 0.2rem /* 20/100 */;
    color: #a2a2a2;
    align-items: center;
  }


  .upload-page > .main > .image_part {
    background-color: #fff;
    margin: 0 auto;
    padding: 0 0.42rem;
    width: 100%;
  }

  .upload-page .main .image_part .uploaded_status {
    padding: 0.34rem /* 34/100 */ 0;
    border-top: 0.01rem /* 1/100 */ solid #f0f1f6;
    border-bottom: 0.01rem /* 1/100 */ solid #f0f1f6;
  }

  .upload-page .main .image_part .uploaded_status .name {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
  }
  .upload-page .main .image_part .uploaded_status .name p {
    margin-right: 1rem;
    font-size: 0.28rem /* 28/100 */;
    color: #151c24;
    line-height: 0.42rem /* 42/100 */;
    font-weight: bold;
  }

  .upload-page .main .image_part .uploaded_status .uploaded_all {
    margin: 0.1rem -0.12rem;
    display: flex;
    flex-flow: row wrap;
  }
  .upload_img_show {
    margin: 0.10rem 0.11rem;
    width: 1.16rem;
    height: 1.16rem;
  }
  .uploaded_all img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .upload-page .main .image_part .upload_img_caption {
    padding-top: 0.34rem;
    margin-bottom: 0.2rem;
    font-size: 0.28rem /* 28/100 */;
    color: #151c24;
    line-height: 0.42rem /* 42/100 */;
    font-weight: bold;
  }

  /deep/ .van-uploader__upload {
    margin-left: 0.175rem;
    font-size: 0;
    background: url("../../assets/image/Upload/photo.png");
    width: 1.4rem;
    height: 1.4rem;
    background-size: 100%;
    border-radius: 0;
  }

  /deep/ .van-uploader__upload-icon {
    display: none;
  }

  /deep/ .van-uploader__wrapper {
    margin: 0 -0.175rem;
  }

  /deep/ .van-uploader__preview {
    margin: 0 0.175rem /* 35/100 */;
    width: 1.4rem;
    height: 1.4rem /* 140/100 */;
    margin-bottom: 0.2rem /* 20/100 */;
  }

  .upload-page .main .image_part button {
    margin-top: 0.48rem /* 48/100 */;
    height: 0.8rem /* 80/100 */;
    background: #54b4ff;
    width: 100%;
    font-size: 0.26rem /* 26/100 */;
    color: #fff;
    border: none;
  }

  input::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #b0b6c3;
  }

  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #b0b6c3;
  }

  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #b0b6c3;
  }

  input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #b0b6c3;
  }
</style>



// WEBPACK FOOTER //
// src/components/Upload/UploadImage.vue